import { useToast as useChakraToast } from "@chakra-ui/react";
import { Toast } from "components/Elements/Toast";
import { useRef } from "react";

export const useToast = () => {
  const toast = useChakraToast();
  const toastIdRef = useRef<string | number | undefined>();

  function close() {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
  }

  const returnFunction = (options: any) => {
    toastIdRef.current = toast({
      position: "top",
      duration: 3000,
      isClosable: true,
      render: () => <Toast onClose={close} {...options} {...toast} />,
      ...options,
    });

    return toastIdRef.current;
  };

  return Object.assign(returnFunction, toast);
};
